import { render, staticRenderFns } from "./MedicalCertificatesTable.vue?vue&type=template&id=d0340e24"
import script from "./MedicalCertificatesTable.vue?vue&type=script&lang=ts"
export * from "./MedicalCertificatesTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports